"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _useAppendCTA = require("../hooks/app/useAppendCTA");
var _useAppSelector = require("../hooks/useAppSelector");
var _useConfig = _interopRequireDefault(require("../hooks/useConfig"));
var _widgetSelectors = require("../store/widget/widgetSelectors");
var _CTAentryPoints = _interopRequireDefault(require("./CTAentryPoints"));
var _GuidedSellingFullPage = _interopRequireDefault(require("./GuidedSellingFullPage"));
var _GuidedSellingModal = _interopRequireDefault(require("./GuidedSellingModal"));
var _PageTemplate = _interopRequireDefault(require("./PageTemplate"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const AppWrapper = () => {
  const CTARenderFunctionArray = (0, _useAppendCTA.useAppendCTA)();
  const {
    showModalView
  } = (0, _useAppSelector.useAppSelector)(_widgetSelectors.selectUiSettings);
  const enableShadowDOM = (0, _useConfig.default)('enableShadowDOM', false);
  return showModalView ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !enableShadowDOM ? /*#__PURE__*/_react.default.createElement(_CTAentryPoints.default, null) : CTARenderFunctionArray.map(element => element()), /*#__PURE__*/_react.default.createElement(_GuidedSellingModal.default, null, /*#__PURE__*/_react.default.createElement(_PageTemplate.default, null))) : /*#__PURE__*/_react.default.createElement(_GuidedSellingFullPage.default, null, /*#__PURE__*/_react.default.createElement(_PageTemplate.default, null));
};
var _default = AppWrapper;
exports.default = _default;